/**
 * dense-sections.ts — F-003.3 Phase 1 (IMPL-P1-001).
 * Metadati sezioni per ContractDenseForm.
 * Riusa STEP_FIELDS da step-fields.ts per evitare duplicazione path.
 */
import { STEP_FIELDS } from './step-fields';

export type DenseSectionId = 'locatore' | 'conduttore' | 'immobile' | 'termini' | 'iban';

export interface DenseSectionMeta {
  id: DenseSectionId;
  title: string;
  fields: ReadonlyArray<string>;
}

export const DENSE_SECTIONS: ReadonlyArray<DenseSectionMeta> = [
  { id: 'locatore',   title: 'Dati del locatore',          fields: STEP_FIELDS[0] },
  { id: 'conduttore', title: 'Dati del conduttore',         fields: STEP_FIELDS[1] },
  { id: 'immobile',   title: 'Immobile e dati catastali',   fields: STEP_FIELDS[2] },
  { id: 'termini',    title: 'Termini economici',           fields: STEP_FIELDS[3] },
  { id: 'iban',       title: 'IBAN per addebito AdE',       fields: STEP_FIELDS[4] },
] as const;
